import ar from "@/i18n/ar.json";
import en from "@/i18n/en.json";

export const translations = { ar, en };

export const getDirection = (lang) => (lang === "ar" ? "rtl" : "ltr");
